export default __webpack_public_path__ + "static/media/raise.b6d1cda0.mp3";